import { ResourceType } from '@repo/api-gw-sdk';

import { useFeatureFlags } from '@/contexts/useFeatureFlags';

const HighFrequencySupportedResourceTypes: ResourceType[] = [
  ResourceType.AwsS3,
];

export const useHighFrequencySupportedResourceTypes = () => {
  const { DynamoDBSupport } = useFeatureFlags();
  return DynamoDBSupport
    ? [ResourceType.AwsDynamoDb, ...HighFrequencySupportedResourceTypes]
    : HighFrequencySupportedResourceTypes;
};
